import { useEffect } from "react";

export const EgosInferno = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div
                className="modal"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    overflowY: "auto", // Enable scrolling for the modal
                    zIndex: 1050,

                }}
            >
                <div
                    className="modal-content"
                    style={{
                        padding: "20px",
                        background: "#fff",
                        borderRadius: "8px",
                        maxWidth: "500px",
                        width: "95%",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                        maxHeight: "95vh", // Limit the modal height to viewport
                        overflowY: "auto", // Enable content scrolling within the modal
                    }}
                >
                    <div className="img-fluid mb-4">
                        <picture><img src="/media/poemseng/egos-inferno.jpg" alt=" Ego's Inferno | Lone Wolf writes " style={{ width: "100%", height: "18rem", objectFit: "cover", borderRadius: "6px", backgroundColor: "gray",}}/></picture>
                    </div>

                    <h2 style={{ textAlign: "center", color: "red" }}>Ego's Inferno</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        In the heart's inferno, ego's blaze does roar, <br />
                        Burning bridges once strong, forevermore. <br />
                        <br />
                        Its flames lick the sky with a hunger untamed, <br />
                        Leaving behind naught but ashes, unnamed. <br />
                        <br />
                        Yet amid the destruction, a whisper of hope, <br />
                        A chance for renewal, a chance to cope. <br />
                        <br />
                        For from the ashes, new life shall arise <br />
                        A phoenix of wisdom, reaching the skies. <br />
                        <br />
                        Though ego's fire rages with unbridled might, <br />
                        In its aftermath, emerges a different light. <br />
                        <br />
                        A chance to rebuild, to mend what was torn, <br />
                        From the lessons learned, a new world is born. <br />
                        <br />
                        Inflamed ego's fire, fierce and wild, <br />
                        Consume the world, like a tempest's child. <br />
                        <br />
                        Reducing all to ashes, it yearns to reign, <br />
                        Yet from destruction, new growth will regain. <br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button
                            type="button"
                            onClick={onClose}
                            className="btn btn-secondary"
                            style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>Close</button>
                    </div>
                </div>
            </div>
        </>
    );
};
